export const GOOGLE_ANALYTICS = "UA-122613642-6";

export const GOOGLE_ADS_CLIENT = "ca-pub-3265727260204834";

export const GOOGLE_ADS_SLOTS = [
    "6517180577", // スロット1
    "1792768244", // スロット2
    "6902219537", // スロット3
    "5066393688", // スロット4
    "9616012784", // スロット5
    "7072242948", // スロット6
    "4984317416", // スロット7
] as const;

export const LOG_TOKEN = "d5(TaY(G*Z*C6T88_bz)9n6rus.vN4H-/gufqntxmg128";

export const DEV_PAYPAL_CLIENT_ID =
    "ARglWuZrd3HYGrlf0IsvAL3wNnNvACnbhewYVtsgGqIEQ-p0bOrTntdbY5azKVgsuhZv3XWw2gprcZXf";

export const PAYPAL_CLIENT_ID =
    "AfWV_LOr9kaKHZYGuAvRsKkOBpFZHp6eCHS0yyP69j4k8SG9FDJViI43pbBLSU3Q7LqktcSkasDz6Ybs";

export const STRIPE_TEST_PUBLIC_KEY =
    "pk_test_51LhhV3HweUPlZUIvprAPWnuvtH8SbyRzeIrS7unJzGNPN2ya3zVdrMmiCS0ByNJmFM8zyWdNPmTex0xVU9qnfGNp00HuzjH6Mj";

export const STRIPE_PRODUCTION_PUBLIC_KEY =
    "pk_live_51LhhV3HweUPlZUIvope4FfZ0jeF2hoOzoIkDKBKN7JDFItTSh2MzVkgpcje7MucjuzWAb9W2ToobUp3FW9CoVURg00oQmqnWcW";
